import { RootState } from "api-store/store";

export const getPodList = (root: RootState) => root.onboarding.podList;
export const getRoles = (root: RootState) => root.onboarding.roles;
export const getIsUserOnboarded = (root: RootState) => root.onboarding.isUserOnboarded;
export const getIsSubmitingUserOnboardForm = (root: RootState) => root.onboarding.isSubmitingUserOnboardForm;
export const getRequests = (root: RootState) => root.onboarding.requests;
export const getRequestDetails = (root: RootState) => root.onboarding.requestDetails;
export const getIsLoadingRequestDetails = (root: RootState) => root.onboarding.isLoadingRequestDetails;
export const getIsSubmitingPodOnboardForm = (root: RootState) => root.onboarding.isSubmitingPodOnboardForm;
export const getIsPodOnboardFormSubmited = (root: RootState) => root.onboarding.isPodOnboardFormSubmited;
export const getIsLoadingRequestStatus = (root: RootState) => root.onboarding.isLoadingRequestStatus;
export const getIsLoadingUserOnboardingFormInitialData = (root: RootState) => root.onboarding.isLoadingUserOnboardingFormInitialData;
// Pagination selectors
export const getTotalCount = (root: RootState) => root.onboarding.totalCount;
export const getCurrentPage = (root: RootState) => root.onboarding.currentPage;
export const getPageSize = (root: RootState) => root.onboarding.pageSize;
export const getTotalPages = (root: RootState) => root.onboarding.totalPages;
export const getHasNext = (root: RootState) => root.onboarding.hasNext;
export const getHasPrevious = (root: RootState) => root.onboarding.hasPrevious;
// Filter selectors
export const getFilters = (root: RootState) => root.onboarding.filters;
// Sort selectors
export const getSortBy = (root: RootState) => root.onboarding.sortBy;
export const getSortOrder = (root: RootState) => root.onboarding.sortOrder;
// Loading selector
export const getIsLoadingRequests = (root: RootState) => root.onboarding.isLoadingRequests;